import _forEach from 'lodash-es/forEach';
import _isArray from 'lodash-es/isArray';
import _isObject from 'lodash-es/isObject';
import _keys from 'lodash-es/keys';
import _isDate from 'lodash-es/isDate';
import * as moment from 'moment';

import { EventEmitter, Input, OnInit, Output, Directive } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import * as g from './utils/groups/index';

import { FormBuilderService } from "libraries/service/formBuilder/formBuilder.service";
// Actions
import { Actions } from './utils/actions/index';

/**
 * GenericForm: Shared variables and functions form
 */
@Directive()
export abstract class GenericForm implements OnInit {

    @Output()
    public submit: EventEmitter<any> = new EventEmitter();

    /* Used to specify a number of items to show */
    @Input()
    public nbItems: number;

    /* Config is setting by default */
    public abstract config: any;

    /* form is a must have. He define the context of the entire form */
    public form: FormGroup;

    /** Get all actions */
    public actions = Actions;

    /** Utils get keys object in template */
    public objectKeys = Object.keys;

    /** DI - fb: Formbuilder */
    constructor(public fb: FormBuilder, public formBuilderService: FormBuilderService) {
    }

    public ngOnInit() {
        this.form = this.fb.group({
            ...this.constructForm()
        });
    }

    /**
     * constructForm Contruct form from config
     * Using for disable or enable part of existing form
     */
    public constructForm(): any {
        const constructForm: any = {};
        const groups: any = g;
        Object.keys(this.config).map((key) => {
            if (this.config[key].show) {
                constructForm[key] = groups[key + 'Group'](
                    this.fb, { count: this.config[key].count, context: this.config[key].context });
            }
        });
        return constructForm;
    }

    /**
     * onSubmit call service to send request to API
     * @param {any} value : values of fields, valid: a boolean after checking Validators
     * @param {boolean} valid
     */
    public onSubmit({ value, valid }: { value: any, valid: any }): void {
        if (valid) {
            this.removeEmpty(value);
            this.formBuilderService.emitSubmitForm(value);
        }
    }

    /**
     * getFormData : get form value whenever we need it
     * @param {any} value : values of fields, valid: a boolean after checking Validators
     * @param {boolean} valid
     */
    public getFormData({ value, valid }: { value: any, valid: boolean }): void {
        this.removeEmpty(value);
        return value;
    }

    /**
     * Reset the entiere form;
     */
    public reset(): void {
        this.form.reset();
    }


    public isDate(_value: any) {
        return (null !== _value) && !isNaN(_value) && ("undefined" !== typeof _value.getDate);
    }

    /**
     * removeEmpty
     * remove empty datas
     * launch convert Date
     */
    public removeEmpty(obj: any) {

        if (typeof obj === 'string' || obj === "") {
            return;
        }

        _forEach(obj, (value: any, key: string) => {


            if (value === "" || value === null || value === undefined) {
                delete obj[key];
            } else if (_isArray(value)) {
                if (value.length === 0) {
                    delete obj[key];
                    return;
                }
                _forEach(value, (v: any, k: string) => {
                    this.removeEmpty(v);
                });
                if (value.length === 0) {
                    delete obj[key];
                }
            } else if (_isObject(value) && !_isDate(value)) {
                if (_keys(value).length === 0) {
                    delete obj[key];
                    return;
                }
                this.removeEmpty(value);
                if (_keys(value).length === 0) {
                    delete obj[key];
                }
            } else if (_isDate(value)) {
                const properDate = moment(value, 'DD-MM-YYYY').format('YYYY-MM-DD');
                obj[key] = properDate;
                return;
            }
        });

        return obj;
    }

    public closeForm(_formName: string, _index: number = -1) {
        if (_index === -1) {
            this.formBuilderService.emitCloseFormWithName(_formName);
        } else {
            this.onSubmit(this.form);
            this.formBuilderService.emitCloseFormWithName(_formName, _index);
        }
    }

    /**
     * Format date to attempted form YYYY-MM-DD
     * @param date {string} : string format
     */
    private formatDate(date: string) {
        return moment(date).format('YYYY-MM-DD');
    }
}
